class PublicAccessService {
  constructor() {
    this.accessToken = '';
  }

  getToken() {
    return this.accessToken;
  }

  setToken(token) {
    this.accessToken = token || '';
  }

  hasToken() {
    return Boolean(this.accessToken);
  }

  clearToken() {
    this.accessToken = '';
  }
}

const publicAccessService = new PublicAccessService();

export default publicAccessService;
